"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var ownKeys = function (o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _a;
var _b, _ViewTransitionMock_instance, _Extendom_referencer, _Extendom_renderer, _Extendom_data, _Extendom_root, _MarkupText_value, _RangeLite_start, _RangeLite_end, _RangeLite_outer, _Renderer_context, _Renderer_targets, _Referencer_elements, _Context_instances, _Context_targets, _Context_renderContent, _ContextItem_resolve, _ContextItem_reject, _ViewTransitionContext_instances, _ViewTransitionContext_elements, _ViewTransitionContext_texts, _ViewTransitionContext_document, _ViewTransitionContext_beforeTransition, _ViewTransitionContext_hasViewTransitionName, _ViewTransitionContext_collectElements, _ViewTransitionContext_wrapText, _ViewTransitionContext_afterTransition, _Evaluator_instances, _Evaluator_evaluator, _Evaluator_create, _ExpressionEvaluator_directive, _ExpressionEvaluator_element, _TextEvaluator_text, _TextEvaluator_spaceable, _ElementSource_instances, _ElementSource_reference, _ElementSource_className, _ElementSource_createEvaluators, _TextSource_evaluator, _ElementTarget_instances, _c, _ElementTarget_update, _ElementTarget_alive, _ElementTarget_targets, _ElementTarget_fragment, _ElementTarget_parent, _ElementTarget_children, _ElementTarget_isChildTarget, _ElementTarget_buildTargets, _ElementTarget_createParentNode, _CreateTarget_instances, _CreateTarget_start, _CreateTarget_end, _CreateTarget_cache, _CreateTarget_createInnerRange, _DirectiveTarget_directive, _AttributeTarget_instances, _AttributeTarget_attributes, _AttributeTarget_listener, _AttributeTarget_callEventListener, _ContentTarget_instances, _ContentTarget_start, _ContentTarget_end, _ContentTarget_isTextContent, _ContentTarget_contentCache, _ContentTarget_identityCache, _ContentTarget_value, _ContentTarget_alive, _ContentTarget_createContent, _ContentTarget_isArrayLike, _ContentTarget_includes, _ArrayContentValue_instances, _ArrayContentValue_source, _ArrayContentValue_cache, _ArrayContentValue_identities, _ArrayContentValue_message, _ArrayContentValue_target, _ArrayContentValue_diffonp, _ArrayContentValue_insert, _TextContentValue_text, _TextContentValue_message, _MarkupContentValue_markup, _ObjectContentValue_children, _ObjectContentValue_targets, _ObjectContentValue_cache, _Cache_caches, _CssVarTarget_keys, _CssclassTarget_names, _CssstyleTarget_keys, _TextTarget_text, _TextTarget_evaluator, _TextTarget_object;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdentityCache = exports.ContentCache = exports.ObjectContentValue = exports.MarkupContentValue = exports.TextContentValue = exports.ArrayContentValue = exports.ContentValue = exports.ContentTarget = exports.SOURCES = exports.STYLESHEETS = exports.FUNCTIONS = exports.Extendom = void 0;
const util = __importStar(require("./util.js"));
const isInputPending = ((_a = navigator.scheduling) === null || _a === void 0 ? void 0 : _a.isInputPending) ? () => navigator.scheduling.isInputPending() : () => false;
class ViewTransitionMock {
  constructor(callback) {
    this.types = new Set();
    let skipTransition;
    const skipped = new Promise((_resolve, reject) => {
      skipTransition = reject;
    });
    this.skipTransition = skipTransition;
    this.updateCallbackDone = new Promise(async resolve => {
      await callback();
      resolve(undefined);
    });
    this.ready = new Promise(async resolve => {
      await Promise.race([this.updateCallbackDone, skipped]);
      resolve(undefined);
    });
    this.finished = new Promise(async resolve => {
      await Promise.race([this.ready, skipped]);
      resolve(undefined);
    });
    __classPrivateFieldGet(_b, _b, "f", _ViewTransitionMock_instance).skipTransition();
    __classPrivateFieldSet(_b, _b, this, "f", _ViewTransitionMock_instance);
  }
}
_b = ViewTransitionMock;
_ViewTransitionMock_instance = {
  value: {
    skipTransition() {}
  }
};
if (!document.startViewTransition) document.startViewTransition = callback => {
  return new ViewTransitionMock(callback);
};
class Extendom {
  constructor(spec, data, root) {
    var _a, _d;
    _Extendom_referencer.set(this, new Referencer());
    _Extendom_renderer.set(this, void 0);
    _Extendom_data.set(this, void 0);
    _Extendom_root.set(this, void 0);
    __classPrivateFieldSet(this, _Extendom_renderer, new Renderer(root.ownerDocument), "f");
    if (root instanceof Element == false) throw new Error();
    const type = (_d = (_a = Object.entries(util.ElementInterfaceTypes).find(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        _name = _ref2[0],
        type = _ref2[1];
      return root instanceof type.ElementInterface;
    })) === null || _a === void 0 ? void 0 : _a[0]) !== null && _d !== void 0 ? _d : 'HTML';
    const parameters = {
      document: root.ownerDocument,
      data,
      type
    };
    const config = util.CONFIG_DIRECTIVES.reduce((object, directive) => {
      return _objectSpread(_objectSpread({}, object), {}, {
        [directive]: false
      });
    }, {});
    const source = new ElementSource(parameters, spec, __classPrivateFieldGet(this, _Extendom_renderer, "f"), __classPrivateFieldGet(this, _Extendom_referencer, "f"), config, root);
    const fragment = source.createDocumentFragment();
    new RootElementTarget(fragment, source, data);
    root.append(fragment);
    __classPrivateFieldSet(this, _Extendom_data, data, "f");
    __classPrivateFieldSet(this, _Extendom_root, root, "f");
    this.render();
  }
  render() {
    let object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __classPrivateFieldGet(this, _Extendom_data, "f");
    return __classPrivateFieldGet(this, _Extendom_renderer, "f").render(object).promise;
  }
  renderViewTransition() {
    let object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __classPrivateFieldGet(this, _Extendom_data, "f");
    return __classPrivateFieldGet(this, _Extendom_renderer, "f").renderViewTransition(object);
  }
  reference(object, reference) {
    var _a;
    return (_a = this.references(object, reference)[0]) !== null && _a !== void 0 ? _a : null;
  }
  references(object, reference) {
    const elements = Array.from(__classPrivateFieldGet(this, _Extendom_referencer, "f").get(object, reference)).filter(element => __classPrivateFieldGet(this, _Extendom_root, "f").contains(element));
    return elements.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_PRECEDING) - 1);
  }
  static markup(value) {
    return new MarkupText(value);
  }
  static css(strings) {
    for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      values[_key - 1] = arguments[_key];
    }
    return strings.raw[0] + values.map((value, index) => '${\'' + value + '\'}' + strings.raw[index + 1]).join('');
  }
}
exports.Extendom = Extendom;
_Extendom_referencer = new WeakMap(), _Extendom_renderer = new WeakMap(), _Extendom_data = new WeakMap(), _Extendom_root = new WeakMap();
exports.FUNCTIONS = {};
exports.STYLESHEETS = {};
exports.SOURCES = new WeakMap();
class MarkupText {
  constructor(value) {
    _MarkupText_value.set(this, void 0);
    __classPrivateFieldSet(this, _MarkupText_value, value, "f");
  }
  toString() {
    return String(__classPrivateFieldGet(this, _MarkupText_value, "f"));
  }
}
_MarkupText_value = new WeakMap();
class RangeLite {
  constructor(start, end) {
    let outer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    _RangeLite_start.set(this, void 0);
    _RangeLite_end.set(this, void 0);
    _RangeLite_outer.set(this, void 0);
    __classPrivateFieldSet(this, _RangeLite_start, start, "f");
    __classPrivateFieldSet(this, _RangeLite_end, end, "f");
    __classPrivateFieldSet(this, _RangeLite_outer, outer, "f");
  }
  insertNode(node) {
    if (__classPrivateFieldGet(this, _RangeLite_outer, "f")) __classPrivateFieldGet(this, _RangeLite_start, "f").before(node);else __classPrivateFieldGet(this, _RangeLite_start, "f").after(node);
  }
  deleteContents() {
    while (__classPrivateFieldGet(this, _RangeLite_start, "f").nextSibling != __classPrivateFieldGet(this, _RangeLite_end, "f")) __classPrivateFieldGet(this, _RangeLite_start, "f").nextSibling.remove();
    if (__classPrivateFieldGet(this, _RangeLite_outer, "f")) {
      __classPrivateFieldGet(this, _RangeLite_start, "f").remove();
      __classPrivateFieldGet(this, _RangeLite_end, "f").remove();
    }
  }
  extractContents() {
    const fragment = __classPrivateFieldGet(this, _RangeLite_start, "f").ownerDocument.createDocumentFragment();
    while (__classPrivateFieldGet(this, _RangeLite_start, "f").nextSibling != __classPrivateFieldGet(this, _RangeLite_end, "f")) fragment.append(__classPrivateFieldGet(this, _RangeLite_start, "f").nextSibling);
    if (__classPrivateFieldGet(this, _RangeLite_outer, "f")) {
      fragment.prepend(__classPrivateFieldGet(this, _RangeLite_start, "f"));
      fragment.append(__classPrivateFieldGet(this, _RangeLite_end, "f"));
    }
    return fragment;
  }
  createContextualFragment(markup) {
    const range = __classPrivateFieldGet(this, _RangeLite_start, "f").ownerDocument.createRange();
    if (__classPrivateFieldGet(this, _RangeLite_outer, "f")) {
      range.setStartBefore(__classPrivateFieldGet(this, _RangeLite_start, "f"));
      range.setEndAfter(__classPrivateFieldGet(this, _RangeLite_end, "f"));
    } else {
      range.setStartAfter(__classPrivateFieldGet(this, _RangeLite_start, "f"));
      range.setEndBefore(__classPrivateFieldGet(this, _RangeLite_end, "f"));
    }
    return range.createContextualFragment(markup);
  }
}
_RangeLite_start = new WeakMap(), _RangeLite_end = new WeakMap(), _RangeLite_outer = new WeakMap();
class Renderer {
  constructor(document) {
    _Renderer_context.set(this, void 0);
    _Renderer_targets.set(this, new Map());
    __classPrivateFieldSet(this, _Renderer_context, new Context(document), "f");
  }
  add(object, target) {
    if (!__classPrivateFieldGet(this, _Renderer_targets, "f").has(object)) __classPrivateFieldGet(this, _Renderer_targets, "f").set(object, new Set());
    __classPrivateFieldGet(this, _Renderer_targets, "f").get(object).add(target);
  }
  delete(object, target) {
    const set = __classPrivateFieldGet(this, _Renderer_targets, "f").get(object);
    set.delete(target);
    if (set.size == 0) __classPrivateFieldGet(this, _Renderer_targets, "f").delete(object);
  }
  render(object) {
    const targets = __classPrivateFieldGet(this, _Renderer_targets, "f").get(object);
    if (!targets) throw new Error('No content');
    return __classPrivateFieldGet(this, _Renderer_context, "f").add(targets);
  }
  async renderViewTransition(object) {
    const value = this.render(object);
    __classPrivateFieldGet(this, _Renderer_context, "f").transition.items.add(value);
    try {
      await value.promise;
      return __classPrivateFieldGet(this, _Renderer_context, "f").transition.transition;
    } finally {
      __classPrivateFieldGet(this, _Renderer_context, "f").transition.items.delete(value);
    }
  }
}
_Renderer_context = new WeakMap(), _Renderer_targets = new WeakMap();
class InterruptError extends Error {}
class Referencer {
  constructor() {
    _Referencer_elements.set(this, new Map());
  }
  add(object, reference, element) {
    if (!__classPrivateFieldGet(this, _Referencer_elements, "f").has(object)) __classPrivateFieldGet(this, _Referencer_elements, "f").set(object, {});
    const record = __classPrivateFieldGet(this, _Referencer_elements, "f").get(object);
    if (!record[reference]) record[reference] = new Set();
    const elements = record[reference];
    elements.add(element);
  }
  delete(object, reference, element) {
    const record = __classPrivateFieldGet(this, _Referencer_elements, "f").get(object);
    const elements = record[reference];
    elements.delete(element);
    if (elements.size == 0) delete record[reference];
    if (Object.keys(record).length == 0) __classPrivateFieldGet(this, _Referencer_elements, "f").delete(object);
  }
  get(object, reference) {
    var _a, _d;
    return (_d = (_a = __classPrivateFieldGet(this, _Referencer_elements, "f").get(object)) === null || _a === void 0 ? void 0 : _a[reference]) !== null && _d !== void 0 ? _d : [];
  }
}
_Referencer_elements = new WeakMap();
class Context {
  constructor(document) {
    _Context_instances.add(this);
    _Context_targets.set(this, new Map());
    this.interrupted = false;
    this.transition = new ViewTransitionContext(document);
  }
  add(targets) {
    var _a;
    this.interrupted = true;
    if (__classPrivateFieldGet(this, _Context_targets, "f").size == 0) requestAnimationFrame(() => {
      this.render();
    });
    const item = (_a = Array.from(targets).map(target => __classPrivateFieldGet(this, _Context_targets, "f").get(target)).find(item => item)) !== null && _a !== void 0 ? _a : new ContextItem(targets);
    for (const target of targets) __classPrivateFieldGet(this, _Context_targets, "f").set(target, item);
    return item;
  }
  async render() {
    while (__classPrivateFieldGet(this, _Context_targets, "f").size > 0) {
      const set = new Set(__classPrivateFieldGet(this, _Context_targets, "f").keys());
      for (const t1 of set) if (Array.from(set).some(t2 => t1 != t2 && t2.contains(t1))) set.delete(t1);
      for (const target of Array.from(set)) if (target.frozen()) set.delete(target);
      if (this.transition.items.size > 0) await this.transition.start(async () => {
        await __classPrivateFieldGet(this, _Context_instances, "m", _Context_renderContent).call(this, set);
      });else await __classPrivateFieldGet(this, _Context_instances, "m", _Context_renderContent).call(this, set);
    }
  }
  resolve(target) {
    const item = __classPrivateFieldGet(this, _Context_targets, "f").get(target);
    if (!item) return;
    __classPrivateFieldGet(this, _Context_targets, "f").delete(target);
    for (const target of item.targets) if (__classPrivateFieldGet(this, _Context_targets, "f").has(target)) return;
    item.resolve();
  }
  reject(target, reason) {
    const item = __classPrivateFieldGet(this, _Context_targets, "f").get(target);
    if (!item) return;
    for (const target of item.targets) __classPrivateFieldGet(this, _Context_targets, "f").delete(target);
    item.reject(reason);
  }
}
_Context_targets = new WeakMap(), _Context_instances = new WeakSet(), _Context_renderContent = async function _Context_renderContent(set) {
  this.interrupted = false;
  try {
    const targets = Array.from(set).sort((a, b) => a.compare(b));
    for (const target of targets) await target.renderContent(this);
  } catch {}
};
class ContextItem {
  constructor(targets) {
    _ContextItem_resolve.set(this, void 0);
    _ContextItem_reject.set(this, void 0);
    this.targets = targets;
    this.promise = new Promise((resolve, reject) => {
      __classPrivateFieldSet(this, _ContextItem_resolve, resolve, "f");
      __classPrivateFieldSet(this, _ContextItem_reject, reject, "f");
    });
  }
  resolve() {
    requestAnimationFrame(() => {
      __classPrivateFieldGet(this, _ContextItem_resolve, "f").call(this);
    });
  }
  reject(reason) {
    requestAnimationFrame(() => {
      __classPrivateFieldGet(this, _ContextItem_reject, "f").call(this, reason);
    });
  }
}
_ContextItem_resolve = new WeakMap(), _ContextItem_reject = new WeakMap();
class ViewTransitionContext {
  constructor(document) {
    _ViewTransitionContext_instances.add(this);
    this.items = new Set();
    _ViewTransitionContext_elements.set(this, new Map());
    _ViewTransitionContext_texts.set(this, new Set());
    _ViewTransitionContext_document.set(this, void 0);
    __classPrivateFieldSet(this, _ViewTransitionContext_document, document, "f");
  }
  async start(callback) {
    __classPrivateFieldGet(this, _ViewTransitionContext_instances, "m", _ViewTransitionContext_beforeTransition).call(this);
    this.transition = __classPrivateFieldGet(this, _ViewTransitionContext_document, "f").startViewTransition(callback);
    __classPrivateFieldGet(this, _ViewTransitionContext_instances, "m", _ViewTransitionContext_afterTransition).call(this, this.transition);
    await this.transition.updateCallbackDone;
  }
}
_ViewTransitionContext_elements = new WeakMap(), _ViewTransitionContext_texts = new WeakMap(), _ViewTransitionContext_document = new WeakMap(), _ViewTransitionContext_instances = new WeakSet(), _ViewTransitionContext_beforeTransition = function _ViewTransitionContext_beforeTransition() {
  const elements = Array.from(this.items).flatMap(item => Array.from(item.targets)).flatMap(target => target.collectElementTargets()).map(target => target.element).filter(element => element != null);
  const set = new Set();
  for (const element of elements) __classPrivateFieldGet(this, _ViewTransitionContext_instances, "m", _ViewTransitionContext_collectElements).call(this, element, set);
  Array.from(set).filter(element => !__classPrivateFieldGet(this, _ViewTransitionContext_instances, "m", _ViewTransitionContext_hasViewTransitionName).call(this, element)).sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_PRECEDING) - 1).forEach((element, index) => {
    const name = `xd-view-transition-name-${index}`;
    element.style.viewTransitionName = name;
    __classPrivateFieldGet(this, _ViewTransitionContext_elements, "f").set(element, name);
    element.classList.add('xd-view-transition-class');
  });
}, _ViewTransitionContext_hasViewTransitionName = function _ViewTransitionContext_hasViewTransitionName(element) {
  const name = getComputedStyle(element).viewTransitionName;
  return name && name != 'none';
}, _ViewTransitionContext_collectElements = function _ViewTransitionContext_collectElements(element, set) {
  const parent = element.parentElement;
  if (!parent || set.has(parent) || parent == __classPrivateFieldGet(this, _ViewTransitionContext_document, "f").documentElement) return;
  for (const child of Array.from(parent.childNodes)) if (child instanceof Element) set.add(child);else if (child instanceof Text && child.data.trim().length > 0) set.add(__classPrivateFieldGet(this, _ViewTransitionContext_instances, "m", _ViewTransitionContext_wrapText).call(this, child));
  __classPrivateFieldGet(this, _ViewTransitionContext_instances, "m", _ViewTransitionContext_collectElements).call(this, parent, set);
}, _ViewTransitionContext_wrapText = function _ViewTransitionContext_wrapText(text) {
  const span = text.ownerDocument.createElement('span');
  text.replaceWith(span);
  span.append(text);
  __classPrivateFieldGet(this, _ViewTransitionContext_texts, "f").add(span);
  return span;
}, _ViewTransitionContext_afterTransition = async function _ViewTransitionContext_afterTransition(transition) {
  try {
    await transition.finished;
  } finally {
    for (const _ref3 of __classPrivateFieldGet(this, _ViewTransitionContext_elements, "f")) {
      var _ref4 = _slicedToArray(_ref3, 2);
      const element = _ref4[0];
      const name = _ref4[1];
      if (__classPrivateFieldGet(this, _ViewTransitionContext_texts, "f").has(element)) element.replaceWith(element.firstChild);else if (element.style.viewTransitionName == name) {
        element.style.viewTransitionName = '';
        element.classList.remove('xd-view-transition-class');
      }
    }
    __classPrivateFieldGet(this, _ViewTransitionContext_elements, "f").clear();
    __classPrivateFieldGet(this, _ViewTransitionContext_texts, "f").clear();
  }
};
class Evaluator {
  constructor(expression, data, evaluable) {
    _Evaluator_instances.add(this);
    _Evaluator_evaluator.set(this, void 0);
    this.expression = expression;
    this.data = data;
    __classPrivateFieldSet(this, _Evaluator_evaluator, __classPrivateFieldGet(this, _Evaluator_instances, "m", _Evaluator_create).call(this, expression, evaluable), "f");
  }
  evaluate(object, scope, element, error) {
    try {
      return __classPrivateFieldGet(this, _Evaluator_evaluator, "f").call(object, this.data, scope, error, element);
    } catch (e) {
      if (e instanceof Error) e.message += ` (${this})`;
      throw e;
    }
  }
}
_Evaluator_evaluator = new WeakMap(), _Evaluator_instances = new WeakSet(), _Evaluator_create = function _Evaluator_create(expression, evaluable) {
  if (expression in exports.FUNCTIONS) return exports.FUNCTIONS[expression];
  if (!evaluable) throw new Error(`Function not found (${expression})`);
  try {
    return new Function('scope', 'data', 'error', 'element', `return ${expression}`);
  } catch (e) {
    if (e instanceof SyntaxError || e instanceof EvalError) e.message += ` (${expression})`;
    throw e;
  }
};
class ExpressionEvaluator extends Evaluator {
  constructor(expression, data, evaluable, element, directive) {
    super(expression, data, evaluable);
    _ExpressionEvaluator_directive.set(this, void 0);
    _ExpressionEvaluator_element.set(this, void 0);
    __classPrivateFieldSet(this, _ExpressionEvaluator_element, element, "f");
    __classPrivateFieldSet(this, _ExpressionEvaluator_directive, directive, "f");
  }
  toString() {
    const name = `data-xd-${__classPrivateFieldGet(this, _ExpressionEvaluator_directive, "f")}`;
    const value = `"${this.expression.replace(/"/g, '\\"')}"`;
    const source = exports.SOURCES.get(__classPrivateFieldGet(this, _ExpressionEvaluator_element, "f"));
    return `${name}=${value}${source ? ' ' + JSON.stringify(source) : ''}`;
  }
}
_ExpressionEvaluator_directive = new WeakMap(), _ExpressionEvaluator_element = new WeakMap();
class TextEvaluator extends Evaluator {
  constructor(text, data, evaluable, spaceable) {
    super(util.toTemplateLiteral(text.data, spaceable), data, evaluable);
    _TextEvaluator_text.set(this, void 0);
    _TextEvaluator_spaceable.set(this, void 0);
    __classPrivateFieldSet(this, _TextEvaluator_text, text, "f");
    __classPrivateFieldSet(this, _TextEvaluator_spaceable, spaceable, "f");
  }
  toString() {
    return __classPrivateFieldGet(this, _TextEvaluator_text, "f").data;
  }
  evaluate(object, scope, element, error) {
    const text = super.evaluate(object, scope, element, error);
    return __classPrivateFieldGet(this, _TextEvaluator_spaceable, "f") ? text : text.replace(/[\t\n\r ]+/g, ' ');
  }
}
_TextEvaluator_text = new WeakMap(), _TextEvaluator_spaceable = new WeakMap();
class Source {
  constructor(document, node) {
    this.cloneable = true;
    this.node = this.createNode(document, node);
  }
  create(_object, _parent) {
    return [this.node.cloneNode()];
  }
}
class ElementSource extends Source {
  constructor(parameters, element, renderer, referencer, config, root) {
    super(parameters.document, root !== null && root !== void 0 ? root : element);
    _ElementSource_instances.add(this);
    this.cloneable = true;
    this.attributes = {};
    _ElementSource_reference.set(this, void 0);
    this.renderer = renderer;
    this.referencer = referencer;
    const attributes = {};
    if (!root) for (const _ref5 of Array.from(element.attributes)) {
      const name = _ref5.name;
      const value = _ref5.value;
      attributes[name] = value;
    }
    this.fragment = util.isFragment(this.node.tagName, attributes, parameters.type);
    const names = [...util.CONFIG_DIRECTIVES, 'reference', 'type', 'subtree', 'css'];
    const directives = names.reduce((directives, directive) => {
      const name = `data-xd-${directive}`;
      const value = attributes[name];
      delete attributes[name];
      return value == undefined ? directives : _objectSpread(_objectSpread({}, directives), {}, {
        [directive]: value
      });
    }, {});
    this.evaluators = __classPrivateFieldGet(this, _ElementSource_instances, "m", _ElementSource_createEvaluators).call(this, attributes, parameters.data, config.evaluable, element);
    this.config = util.CONFIG_DIRECTIVES.reduce((record, directive) => {
      return _objectSpread(_objectSpread({}, record), {}, {
        [directive]: config[directive] || directive in directives
      });
    }, {});
    __classPrivateFieldSet(this, _ElementSource_reference, directives.reference, "f");
    if (directives.css) this.css = __classPrivateFieldGet(this, _ElementSource_instances, "m", _ElementSource_className).call(this, directives.css, parameters.document);
    const type = directives.type,
      subtree = directives.subtree;
    if (this.evaluators.attribute) this.attributes = Object.entries(attributes).reduce((attributes, _ref6) => {
      let _ref7 = _slicedToArray(_ref6, 2),
        name = _ref7[0],
        value = _ref7[1];
      return _objectSpread(_objectSpread({}, attributes), {}, {
        [name]: value || true
      });
    }, {});else for (const _ref8 of Object.entries(attributes)) {
      var _ref9 = _slicedToArray(_ref8, 2);
      const name = _ref9[0];
      const value = _ref9[1];
      if (value) this.node.setAttribute(name, value);else this.node.toggleAttribute(name);
    }
    this.children = this.createChildSources(parameters, subtree ? element.ownerDocument.querySelector(subtree) : element);
    if (__classPrivateFieldGet(this, _ElementSource_reference, "f") || this.css || type || this.fragment || Object.keys(this.evaluators).length > 0 || this.children.some(child => !child.cloneable)) this.cloneable = false;
    this.node.append(...this.children.map(child => child.node));
  }
  create(object, parent) {
    if (this.cloneable) return [this.node.cloneNode(true)];
    const fragment = this.createDocumentFragment();
    const constructor = this.evaluators.create ? CreateTarget : ElementTarget;
    return [fragment, new constructor(fragment, this, object, parent)];
  }
  createDocumentFragment() {
    return this.node.ownerDocument.createDocumentFragment();
  }
  addReference(object, element) {
    if (__classPrivateFieldGet(this, _ElementSource_reference, "f") && element) this.referencer.add(object, __classPrivateFieldGet(this, _ElementSource_reference, "f"), element);
  }
  deleteReference(object, element) {
    if (__classPrivateFieldGet(this, _ElementSource_reference, "f") && element) this.referencer.delete(object, __classPrivateFieldGet(this, _ElementSource_reference, "f"), element);
  }
  createNode(document, node) {
    return document.createElement(node.tagName);
  }
  createChildSources(parameters, element) {
    const children = Array.from(element.childNodes).filter(child => child instanceof Element || child instanceof Text && child.data.trim().length > 0 || child instanceof CDATASection || child instanceof ProcessingInstruction);
    return children.map(child => this.createSource(parameters, child, element.namespaceURI));
  }
  createSource(parameters, child, namespace) {
    if (child instanceof Element) return namespace == child.namespaceURI || !namespace ? new ElementSource(parameters, child, this.renderer, this.referencer, this.config) : new ForeignElementSource(document, child);
    if (child instanceof Text) return new TextSource(document, child, parameters.data, this.config, false);
    if (child instanceof CDATASection) return new TextSource(document, child, parameters.data, this.config, true);
    if (child instanceof ProcessingInstruction) return new ProcessingInstructionSource(document, child);
    throw new Error();
  }
}
_ElementSource_reference = new WeakMap(), _ElementSource_instances = new WeakSet(), _ElementSource_className = function _ElementSource_className(css, document) {
  if (css in exports.STYLESHEETS) return exports.STYLESHEETS[css];
  if (!this.config.evaluable) throw new Error(`css not found (${css})`);
  if (!Extendom.style) {
    Extendom.style = document.createElement('style');
    document.head.append(Extendom.style);
  }
  const sheet = Extendom.style.sheet;
  const index = sheet.cssRules.length;
  sheet.insertRule(`xd-${index} {${util.cssvars(css).css}}`, index);
  return String(index);
}, _ElementSource_createEvaluators = function _ElementSource_createEvaluators(attributes, data, evaluable, element) {
  return util.DIRECTIVES.reduce((evaluators, directive) => {
    const name = `data-xd-${directive}`;
    if (name in attributes) {
      const expression = attributes[name];
      delete attributes[name];
      return _objectSpread(_objectSpread({}, evaluators), {}, {
        [directive]: new ExpressionEvaluator(expression, data, evaluable, element, directive)
      });
    }
    return evaluators;
  }, {});
};
class ForeignElementSource extends Source {
  createNode(document, node) {
    return document.importNode(node, true);
  }
  create(_object, _parent) {
    return [this.node.cloneNode(true)];
  }
}
class TextSource extends Source {
  constructor(document, text, data, config, raw) {
    super(document, text);
    _TextSource_evaluator.set(this, void 0);
    this.cloneable = raw || !util.isTemplateLiteral(text.data);
    if (!this.cloneable) __classPrivateFieldSet(this, _TextSource_evaluator, new TextEvaluator(this.node, data, config.evaluable, config.spaceable), "f");else if (!config.spaceable) this.node.data = this.node.data.replace(/[\t\n\r ]+/g, ' ');
  }
  create(object) {
    if (!__classPrivateFieldGet(this, _TextSource_evaluator, "f")) return [this.node.cloneNode()];
    const text = this.node.ownerDocument.createTextNode('');
    return [text, new TextTarget(text, __classPrivateFieldGet(this, _TextSource_evaluator, "f"), object)];
  }
  createNode(document, node) {
    return document.createTextNode(node.data);
  }
}
_TextSource_evaluator = new WeakMap();
class ProcessingInstructionSource extends Source {
  createNode(document, node) {
    return document.createProcessingInstruction(node.target, node.data);
  }
}
class Target {}
class ElementTarget extends Target {
  constructor(fragment, source, object, parent) {
    super();
    _ElementTarget_instances.add(this);
    this.create = false;
    _ElementTarget_update.set(this, true);
    _ElementTarget_alive.set(this, false);
    _ElementTarget_targets.set(this, []);
    _ElementTarget_fragment.set(this, void 0);
    _ElementTarget_parent.set(this, void 0);
    _ElementTarget_children.set(this, []);
    __classPrivateFieldSet(this, _ElementTarget_fragment, fragment, "f");
    this.source = source;
    this.object = object;
    __classPrivateFieldSet(this, _ElementTarget_parent, parent, "f");
  }
  async render(scope, context) {
    this.scope = scope;
    try {
      await this.renderElement(scope, context);
    } catch (error) {
      if (this.source.evaluators.error) this.source.evaluators.error.evaluate(this.object, scope, this.element, error);else throw error;
    }
    if (isInputPending() && this.source.config.interruptible) await new Promise(resolve => {
      setTimeout(resolve);
    });
  }
  frozen() {
    return __classPrivateFieldGet(this, _ElementTarget_update, "f") ? __classPrivateFieldGet(this, _ElementTarget_parent, "f").frozen() : false;
  }
  terminate() {
    var _a;
    (_a = this.source.evaluators.terminal) === null || _a === void 0 ? void 0 : _a.evaluate(this.object, this.scope, this.element);
    for (const target of __classPrivateFieldGet(this, _ElementTarget_targets, "f")) if (target instanceof _c || target instanceof ContentTarget) target.terminate();
    if (!this.source.config.cacheable) __classPrivateFieldGet(this, _ElementTarget_targets, "f").splice(0);
    this.source.deleteReference(this.object, this.element);
    __classPrivateFieldSet(this, _ElementTarget_alive, false, "f");
  }
  uncache() {
    var _a;
    if (__classPrivateFieldGet(this, _ElementTarget_alive, "f")) {
      for (const target of __classPrivateFieldGet(this, _ElementTarget_targets, "f")) if (target instanceof _c) target.uncache();
    } else {
      __classPrivateFieldGet(this, _ElementTarget_targets, "f").splice(0);
      (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      this.create = false;
    }
  }
  collectElementTargets() {
    const targets = __classPrivateFieldGet(this, _ElementTarget_targets, "f").filter(target => target instanceof _c || target instanceof ContentTarget);
    return [this, ...targets.flatMap(target => target.collectElementTargets())];
  }
  predicate(directive, scope) {
    const evaluator = this.source.evaluators[directive];
    return evaluator ? Boolean(evaluator.evaluate(this.object, scope, this.element)) : true;
  }
  async renderElement(scope, context) {
    if (this.create) await this.renderTargets(scope, context);else await this.createContents(scope, context);
    this.create = true;
  }
  async renderTargets(scope, context, parent) {
    var _a;
    if (__classPrivateFieldGet(this, _ElementTarget_alive, "f") && this.create) {
      __classPrivateFieldSet(this, _ElementTarget_update, this.predicate('update', scope), "f");
      if (!__classPrivateFieldGet(this, _ElementTarget_update, "f")) return;
    }
    for (const target of __classPrivateFieldGet(this, _ElementTarget_targets, "f")) await target.render(__classPrivateFieldGet(this, _ElementTarget_instances, "m", _ElementTarget_isChildTarget).call(this, target) ? this.scope : scope, context);
    parent === null || parent === void 0 ? void 0 : parent.append(...__classPrivateFieldGet(this, _ElementTarget_children, "f").splice(0));
    if (!__classPrivateFieldGet(this, _ElementTarget_alive, "f")) {
      (_a = this.source.evaluators.initial) === null || _a === void 0 ? void 0 : _a.evaluate(this.object, scope, this.element);
      this.source.addReference(this.object, this.element);
    }
    __classPrivateFieldSet(this, _ElementTarget_alive, true, "f");
  }
  async createContents(scope, context) {
    __classPrivateFieldGet(this, _ElementTarget_instances, "m", _ElementTarget_buildTargets).call(this);
    const parent = __classPrivateFieldGet(this, _ElementTarget_instances, "m", _ElementTarget_createParentNode).call(this);
    await this.renderTargets(scope, context, parent);
    this.appendParentNode(parent);
  }
  appendParentNode(parent) {
    __classPrivateFieldGet(this, _ElementTarget_fragment, "f").append(parent);
  }
}
_c = ElementTarget, _ElementTarget_update = new WeakMap(), _ElementTarget_alive = new WeakMap(), _ElementTarget_targets = new WeakMap(), _ElementTarget_fragment = new WeakMap(), _ElementTarget_parent = new WeakMap(), _ElementTarget_children = new WeakMap(), _ElementTarget_instances = new WeakSet(), _ElementTarget_isChildTarget = function _ElementTarget_isChildTarget(target) {
  return target instanceof _c || target instanceof TextTarget;
}, _ElementTarget_buildTargets = function _ElementTarget_buildTargets() {
  if (this.source.evaluators.before) __classPrivateFieldGet(this, _ElementTarget_targets, "f").push(new BeforeTarget(this));
  if (this.source.evaluators.attribute) __classPrivateFieldGet(this, _ElementTarget_targets, "f").push(new AttributeTarget(this));
  if (this.source.evaluators.scope) __classPrivateFieldGet(this, _ElementTarget_targets, "f").push(new ScopeTarget(this));
  if (this.source.evaluators.content) {
    const fragment = this.source.createDocumentFragment();
    __classPrivateFieldGet(this, _ElementTarget_children, "f").push(fragment);
    __classPrivateFieldGet(this, _ElementTarget_targets, "f").push(new ContentTarget(this, fragment));
  } else {
    const tuples = this.source.children.map(source => source.create(this.object, __classPrivateFieldGet(this, _ElementTarget_parent, "f")));
    __classPrivateFieldGet(this, _ElementTarget_children, "f").push(...tuples.map(tuple => tuple[0]));
    __classPrivateFieldGet(this, _ElementTarget_targets, "f").push(...tuples.map(tuple => tuple[1]).filter(target => target != null));
  }
  if (this.source.evaluators.property) __classPrivateFieldGet(this, _ElementTarget_targets, "f").push(new PropertyTarget(this));
  if (this.source.evaluators.cssvar) __classPrivateFieldGet(this, _ElementTarget_targets, "f").push(new CssVarTarget(this));
  if (this.source.evaluators.cssclass) __classPrivateFieldGet(this, _ElementTarget_targets, "f").push(new CssclassTarget(this));
  if (this.source.evaluators.cssstyle) __classPrivateFieldGet(this, _ElementTarget_targets, "f").push(new CssstyleTarget(this));
  if (this.source.evaluators.after) __classPrivateFieldGet(this, _ElementTarget_targets, "f").push(new AfterTarget(this));
}, _ElementTarget_createParentNode = function _ElementTarget_createParentNode() {
  if (this.source.fragment) return this.source.createDocumentFragment();
  this.element = this.source.node.cloneNode();
  if (this.source.css) this.element.classList.add(`xd-${this.source.css}`);
  return this.element;
};
class CreateTarget extends ElementTarget {
  constructor(fragment, source, object, parent) {
    super(fragment, source, object, parent);
    _CreateTarget_instances.add(this);
    _CreateTarget_start.set(this, void 0);
    _CreateTarget_end.set(this, void 0);
    _CreateTarget_cache.set(this, null);
    __classPrivateFieldSet(this, _CreateTarget_start, fragment.ownerDocument.createTextNode(''), "f");
    __classPrivateFieldSet(this, _CreateTarget_end, fragment.ownerDocument.createTextNode(''), "f");
    fragment.append(__classPrivateFieldGet(this, _CreateTarget_start, "f"), __classPrivateFieldGet(this, _CreateTarget_end, "f"));
  }
  uncache() {
    super.uncache();
    __classPrivateFieldSet(this, _CreateTarget_cache, null, "f");
  }
  async renderElement(scope, context) {
    const create = this.predicate('create', scope);
    if (create == this.create) await this.renderTargets(scope, context);else if (create) {
      if (__classPrivateFieldGet(this, _CreateTarget_cache, "f")) {
        __classPrivateFieldGet(this, _CreateTarget_instances, "m", _CreateTarget_createInnerRange).call(this).insertNode(__classPrivateFieldGet(this, _CreateTarget_cache, "f"));
        __classPrivateFieldSet(this, _CreateTarget_cache, null, "f");
        await this.renderTargets(scope, context);
      } else await this.createContents(scope, context);
    } else if (this.create) {
      if (this.source.config.cacheable) __classPrivateFieldSet(this, _CreateTarget_cache, __classPrivateFieldGet(this, _CreateTarget_instances, "m", _CreateTarget_createInnerRange).call(this).extractContents(), "f");else {
        __classPrivateFieldGet(this, _CreateTarget_instances, "m", _CreateTarget_createInnerRange).call(this).deleteContents();
        delete this.element;
      }
      this.terminate();
    }
    this.create = create;
  }
  appendParentNode(parent) {
    __classPrivateFieldGet(this, _CreateTarget_start, "f").after(parent);
  }
}
_CreateTarget_start = new WeakMap(), _CreateTarget_end = new WeakMap(), _CreateTarget_cache = new WeakMap(), _CreateTarget_instances = new WeakSet(), _CreateTarget_createInnerRange = function _CreateTarget_createInnerRange() {
  return new RangeLite(__classPrivateFieldGet(this, _CreateTarget_start, "f"), __classPrivateFieldGet(this, _CreateTarget_end, "f"));
};
class RootElementTarget extends ElementTarget {
  constructor(fragment, source, data) {
    super(fragment, source, data, null);
    const target = new RootContentTarget(this, fragment, data);
    source.renderer.add(data, target);
  }
  frozen() {
    return false;
  }
}
class DirectiveTarget extends Target {
  constructor(directive, owner) {
    super();
    _DirectiveTarget_directive.set(this, void 0);
    __classPrivateFieldSet(this, _DirectiveTarget_directive, directive, "f");
    this.owner = owner;
  }
  get evaluator() {
    return this.owner.source.evaluators[__classPrivateFieldGet(this, _DirectiveTarget_directive, "f")];
  }
  evaluate(scope) {
    let nullable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const value = this.evaluator.evaluate(this.owner.object, scope, this.owner.element);
    if (!nullable && value == null) throw new Error(`Expresion returns nullish value (${this.evaluator})`);
    return value;
  }
}
_DirectiveTarget_directive = new WeakMap();
class BeforeTarget extends DirectiveTarget {
  constructor(owner) {
    super('before', owner);
  }
  async render(scope) {
    this.evaluate(scope, true);
  }
}
class AttributeTarget extends DirectiveTarget {
  constructor(owner) {
    super('attribute', owner);
    _AttributeTarget_instances.add(this);
    _AttributeTarget_attributes.set(this, {});
    _AttributeTarget_listener.set(this, async event => {
      const value = __classPrivateFieldGet(this, _AttributeTarget_attributes, "f")['on' + event.type];
      const object = await __classPrivateFieldGet(this, _AttributeTarget_instances, "m", _AttributeTarget_callEventListener).call(this, value, event);
      if (object != null) this.owner.source.renderer.render(object);
    });
  }
  async render(scope) {
    const element = this.owner.element;
    const attributes = this.evaluate(scope);
    const setAttribute = (name, value) => {
      if (typeof value == 'boolean') element.toggleAttribute(name, value);else element.setAttribute(name, value);
    };
    for (const _ref10 of Object.entries(attributes)) {
      var _ref11 = _slicedToArray(_ref10, 2);
      const name = _ref11[0];
      const value = _ref11[1];
      if (value == null || name.startsWith('on') || typeof value == 'boolean') continue;
      attributes[name] = toDOMString(value, this.evaluator.toString());
    }
    for (const _ref12 of Object.entries(attributes)) {
      var _ref13 = _slicedToArray(_ref12, 2);
      const name = _ref13[0];
      const value = _ref13[1];
      if (value == null) {
        delete attributes[name];
      } else if (name.startsWith('on')) {
        if (name in __classPrivateFieldGet(this, _AttributeTarget_attributes, "f")) delete __classPrivateFieldGet(this, _AttributeTarget_attributes, "f")[name];else element.addEventListener(name.substring(2), __classPrivateFieldGet(this, _AttributeTarget_listener, "f"));
      } else if (name in __classPrivateFieldGet(this, _AttributeTarget_attributes, "f")) {
        if (value != __classPrivateFieldGet(this, _AttributeTarget_attributes, "f")[name]) setAttribute(name, attributes[name]);
        delete __classPrivateFieldGet(this, _AttributeTarget_attributes, "f")[name];
      } else setAttribute(name, attributes[name]);
    }
    for (const name in __classPrivateFieldGet(this, _AttributeTarget_attributes, "f")) if (name.startsWith('on')) element.removeEventListener(name.substring(2), __classPrivateFieldGet(this, _AttributeTarget_listener, "f"));else element.removeAttribute(name);
    __classPrivateFieldSet(this, _AttributeTarget_attributes, attributes, "f");
  }
  evaluate(scope) {
    return _objectSpread(_objectSpread({}, this.owner.source.attributes), super.evaluate(scope));
  }
}
_AttributeTarget_attributes = new WeakMap(), _AttributeTarget_listener = new WeakMap(), _AttributeTarget_instances = new WeakSet(), _AttributeTarget_callEventListener = function _AttributeTarget_callEventListener(value, event) {
  const second = {
    data: this.evaluator.data,
    scope: this.owner.scope,
    element: this.owner.element
  };
  if (typeof value == 'function') return value.call(this.owner.object, event, second);
  if (typeof value == 'object' && value && 'handleEvent' in value && typeof value.handleEvent == 'function') return value.handleEvent(event, second);
  if (this.owner.source.config.evaluable && typeof value == 'string') try {
    return Function(value).call(this.owner.object, event, second);
  } catch (e) {
    if (e instanceof EvalError) e.message += ` (${value})`;
    throw e;
  }
  throw new Error(`Unevaluable (${value})`);
};
class ScopeTarget extends DirectiveTarget {
  constructor(owner) {
    super('scope', owner);
  }
  async render(scope) {
    this.owner.scope = this.evaluate(scope, true);
  }
}
class ContentTarget extends DirectiveTarget {
  constructor(owner, fragment) {
    super('content', owner);
    _ContentTarget_instances.add(this);
    _ContentTarget_start.set(this, void 0);
    _ContentTarget_end.set(this, void 0);
    _ContentTarget_isTextContent.set(this, void 0);
    _ContentTarget_contentCache.set(this, new ContentCache());
    _ContentTarget_identityCache.set(this, new IdentityCache());
    _ContentTarget_value.set(this, void 0);
    _ContentTarget_alive.set(this, false);
    __classPrivateFieldSet(this, _ContentTarget_start, fragment.ownerDocument.createTextNode(''), "f");
    __classPrivateFieldSet(this, _ContentTarget_end, fragment.ownerDocument.createTextNode(''), "f");
    fragment.append(__classPrivateFieldGet(this, _ContentTarget_start, "f"), __classPrivateFieldGet(this, _ContentTarget_end, "f"));
    __classPrivateFieldSet(this, _ContentTarget_isTextContent, owner.source.children.every(source => source.cloneable), "f");
    // this.#value = new ObjectContentValue(
    //     this.#start, this.#end, ContentTarget.#INITIAL, this.#contentCache, owner);
  }
  async render(scope, context) {
    await this.updateValue(scope);
    await this.renderContent(context);
  }
  async renderContent(context) {
    if (context.interrupted) throw new InterruptError();
    try {
      await __classPrivateFieldGet(this, _ContentTarget_value, "f").render(this.owner.scope, context);
      context.resolve(this);
    } catch (reason) {
      if (reason instanceof InterruptError) throw reason;
      context.reject(this, reason);
      throw reason;
    }
    if (!__classPrivateFieldGet(this, _ContentTarget_alive, "f")) this.owner.source.renderer.add(__classPrivateFieldGet(this, _ContentTarget_value, "f").value, this);
    __classPrivateFieldSet(this, _ContentTarget_alive, true, "f");
  }
  terminate() {
    if (!__classPrivateFieldGet(this, _ContentTarget_value, "f")) return;
    __classPrivateFieldGet(this, _ContentTarget_value, "f").terminate();
    this.owner.source.renderer.delete(__classPrivateFieldGet(this, _ContentTarget_value, "f").value, this);
    __classPrivateFieldSet(this, _ContentTarget_alive, false, "f");
  }
  contains(other) {
    if (this == other) return true;
    if (this.owner.source.node == other.owner.source.node) return __classPrivateFieldGet(this, _ContentTarget_instances, "m", _ContentTarget_includes).call(this, other);else return this.owner.source.node.contains(other.owner.source.node);
  }
  compare(other) {
    return (__classPrivateFieldGet(this, _ContentTarget_start, "f").compareDocumentPosition(__classPrivateFieldGet(other, _ContentTarget_start, "f")) & Node.DOCUMENT_POSITION_PRECEDING) - 1;
  }
  frozen() {
    return this.owner.frozen();
  }
  uncache() {
    __classPrivateFieldGet(this, _ContentTarget_value, "f").uncache();
    __classPrivateFieldGet(this, _ContentTarget_contentCache, "f").clear();
    __classPrivateFieldGet(this, _ContentTarget_identityCache, "f").clear();
  }
  extract() {
    return new RangeLite(__classPrivateFieldGet(this, _ContentTarget_start, "f"), __classPrivateFieldGet(this, _ContentTarget_end, "f"), true).extractContents();
  }
  insert(fragment) {
    __classPrivateFieldGet(this, _ContentTarget_start, "f").before(fragment);
  }
  createIdentityContentTarget(fragment, value) {
    return new IdentityContentTarget(this.owner, fragment, value, this);
  }
  collectElementTargets() {
    var _a, _d;
    return (_d = (_a = __classPrivateFieldGet(this, _ContentTarget_value, "f")) === null || _a === void 0 ? void 0 : _a.collectElementTargets()) !== null && _d !== void 0 ? _d : [];
  }
  async updateValue(scope) {
    var _a, _d;
    const value = this.evaluate(scope);
    if (Object.is(value, (_a = __classPrivateFieldGet(this, _ContentTarget_value, "f")) === null || _a === void 0 ? void 0 : _a.value)) return;
    if (__classPrivateFieldGet(this, _ContentTarget_value, "f") instanceof ArrayContentValue && __classPrivateFieldGet(this, _ContentTarget_instances, "m", _ContentTarget_isArrayLike).call(this, value)) {
      __classPrivateFieldGet(this, _ContentTarget_value, "f").updateValue(value);
      return;
    }
    this.terminate();
    if (this.owner.source.config.cacheable) (_d = __classPrivateFieldGet(this, _ContentTarget_value, "f")) === null || _d === void 0 ? void 0 : _d.cache();
    new RangeLite(__classPrivateFieldGet(this, _ContentTarget_start, "f"), __classPrivateFieldGet(this, _ContentTarget_end, "f")).deleteContents();
    __classPrivateFieldSet(this, _ContentTarget_value, __classPrivateFieldGet(this, _ContentTarget_instances, "m", _ContentTarget_createContent).call(this, value), "f");
  }
  get message() {
    return this.evaluator.toString();
  }
}
exports.ContentTarget = ContentTarget;
_ContentTarget_start = new WeakMap(), _ContentTarget_end = new WeakMap(), _ContentTarget_isTextContent = new WeakMap(), _ContentTarget_contentCache = new WeakMap(), _ContentTarget_identityCache = new WeakMap(), _ContentTarget_value = new WeakMap(), _ContentTarget_alive = new WeakMap(), _ContentTarget_instances = new WeakSet(), _ContentTarget_createContent = function _ContentTarget_createContent(value) {
  if (__classPrivateFieldGet(this, _ContentTarget_instances, "m", _ContentTarget_isArrayLike).call(this, value)) return new ArrayContentValue(__classPrivateFieldGet(this, _ContentTarget_start, "f"), __classPrivateFieldGet(this, _ContentTarget_end, "f"), value, this.owner.source, this.message, __classPrivateFieldGet(this, _ContentTarget_identityCache, "f"), this);
  if (__classPrivateFieldGet(this, _ContentTarget_isTextContent, "f")) return value instanceof MarkupText ? new MarkupContentValue(__classPrivateFieldGet(this, _ContentTarget_start, "f"), __classPrivateFieldGet(this, _ContentTarget_end, "f"), value) : new TextContentValue(__classPrivateFieldGet(this, _ContentTarget_start, "f"), __classPrivateFieldGet(this, _ContentTarget_end, "f"), value, this.message);
  return new ObjectContentValue(__classPrivateFieldGet(this, _ContentTarget_start, "f"), __classPrivateFieldGet(this, _ContentTarget_end, "f"), value, __classPrivateFieldGet(this, _ContentTarget_contentCache, "f"), this.owner);
}, _ContentTarget_isArrayLike = function _ContentTarget_isArrayLike(value) {
  return Array.isArray(value) || value && typeof value == 'object' && 'length' in value && typeof value.length == 'number' && value.length >= 0 && Number.isInteger(value.length) && [...Array(value.length)].every((_, i) => i in value);
}, _ContentTarget_includes = function _ContentTarget_includes(other) {
  if (other instanceof IdentityContentTarget) {
    const parent = other.parent;
    if (parent == this || parent && __classPrivateFieldGet(this, _ContentTarget_instances, "m", _ContentTarget_includes).call(this, parent)) return true;
  }
  return false;
};
class ContentValue {
  constructor(start, end, value) {
    this.start = start;
    this.end = end;
    this.value = value;
  }
  createInnerRange() {
    return new RangeLite(this.start, this.end);
  }
}
exports.ContentValue = ContentValue;
class ArrayContentValue extends ContentValue {
  constructor(start, end, value, source, message, cache, target) {
    super(start, end, Array.isArray(value) ? value : Array.from(value));
    _ArrayContentValue_instances.add(this);
    _ArrayContentValue_source.set(this, void 0);
    _ArrayContentValue_cache.set(this, void 0);
    _ArrayContentValue_identities.set(this, []);
    _ArrayContentValue_message.set(this, void 0);
    _ArrayContentValue_target.set(this, void 0);
    __classPrivateFieldSet(this, _ArrayContentValue_source, source, "f");
    __classPrivateFieldSet(this, _ArrayContentValue_message, message, "f");
    __classPrivateFieldSet(this, _ArrayContentValue_cache, cache, "f");
    __classPrivateFieldSet(this, _ArrayContentValue_target, target, "f");
  }
  async render(_scope, context) {
    const ses = __classPrivateFieldGet(this, _ArrayContentValue_instances, "m", _ArrayContentValue_diffonp).call(this, __classPrivateFieldGet(this, _ArrayContentValue_identities, "f").map(target => target.value), this.value);
    const tuples = ses.filter(i => i < 0).sort((a, b) => a - b).map(i => {
      const target = __classPrivateFieldGet(this, _ArrayContentValue_identities, "f").splice(-i - 1, 1)[0];
      return [target.value, target, target.extract()];
    });
    tuples.reverse();
    for (const i of ses.filter(i => i >= 0).sort((a, b) => a - b)) {
      const value = this.value[i];
      if (value == null) throw new Error(`Array(Like) includes nullish value (${__classPrivateFieldGet(this, _ArrayContentValue_message, "f")})`);
      const index = tuples.findIndex(tuple => Object.is(tuple[0], value));
      if (index >= 0) {
        const tuple = tuples.splice(index, 1)[0];
        __classPrivateFieldGet(this, _ArrayContentValue_instances, "m", _ArrayContentValue_insert).call(this, i, tuple[2]);
        __classPrivateFieldGet(this, _ArrayContentValue_identities, "f").splice(i, 0, tuple[1]);
      } else if (__classPrivateFieldGet(this, _ArrayContentValue_cache, "f").has(value)) {
        const _classPrivateFieldGe = __classPrivateFieldGet(this, _ArrayContentValue_cache, "f").pop(value),
          target = _classPrivateFieldGe.target,
          fragment = _classPrivateFieldGe.fragment;
        __classPrivateFieldGet(this, _ArrayContentValue_instances, "m", _ArrayContentValue_insert).call(this, i, fragment);
        __classPrivateFieldGet(this, _ArrayContentValue_identities, "f").splice(i, 0, target);
      } else {
        const fragment = __classPrivateFieldGet(this, _ArrayContentValue_source, "f").createDocumentFragment();
        const target = __classPrivateFieldGet(this, _ArrayContentValue_target, "f").createIdentityContentTarget(fragment, value);
        __classPrivateFieldGet(this, _ArrayContentValue_instances, "m", _ArrayContentValue_insert).call(this, i, fragment);
        __classPrivateFieldGet(this, _ArrayContentValue_identities, "f").splice(i, 0, target);
      }
    }
    for (const tuple of tuples) tuple[1].terminate();
    if (__classPrivateFieldGet(this, _ArrayContentValue_source, "f").config.cacheable) for (const tuple of tuples) __classPrivateFieldGet(this, _ArrayContentValue_cache, "f").push(tuple[0], {
      target: tuple[1],
      fragment: tuple[2]
    });
    for (const target of __classPrivateFieldGet(this, _ArrayContentValue_identities, "f")) await target.renderContent(context);
  }
  terminate() {
    for (const identity of __classPrivateFieldGet(this, _ArrayContentValue_identities, "f")) identity.terminate();
  }
  cache() {
    for (const identity of __classPrivateFieldGet(this, _ArrayContentValue_identities, "f")) __classPrivateFieldGet(this, _ArrayContentValue_cache, "f").push(identity.value, {
      target: identity,
      fragment: identity.extract()
    });
  }
  uncache() {
    for (const identity of __classPrivateFieldGet(this, _ArrayContentValue_identities, "f")) identity.uncache();
  }
  collectElementTargets() {
    return __classPrivateFieldGet(this, _ArrayContentValue_identities, "f").flatMap(target => target.collectElementTargets());
  }
  updateValue(value) {
    this.value = Array.isArray(value) ? value : Array.from(value);
  }
}
exports.ArrayContentValue = ArrayContentValue;
_ArrayContentValue_source = new WeakMap(), _ArrayContentValue_cache = new WeakMap(), _ArrayContentValue_identities = new WeakMap(), _ArrayContentValue_message = new WeakMap(), _ArrayContentValue_target = new WeakMap(), _ArrayContentValue_instances = new WeakSet(), _ArrayContentValue_diffonp = function _ArrayContentValue_diffonp(a, b) {
  const m = a.length;
  const n = b.length;
  if (m > n) return __classPrivateFieldGet(this, _ArrayContentValue_instances, "m", _ArrayContentValue_diffonp).call(this, b, a).map(n => -n - 1);
  const delta = n - m;
  const fp = new Int32Array(m + n + 3).fill(-1);
  const paths = new Array(m + n + 3);
  const offset = m + 1;
  const snake = k => {
    const p = fp[k - 1 + offset] + 1;
    const q = fp[k + 1 + offset];
    let y = Math.max(p, q);
    let x = y - k;
    let length = 0;
    while (x < m && y < n && Object.is(a[x], b[y])) {
      ++x;
      ++y;
      ++length;
    }
    const path = p > q ? paths[k - 1 + offset] : paths[k + 1 + offset];
    paths[k + offset] = length > 0 ? {
      x,
      y,
      length,
      path
    } : path;
    return y;
  };
  for (let p = 0; p <= m; ++p) {
    for (let k = -p; k < delta; ++k) fp[k + offset] = snake(k);
    for (let k = p + delta; k > delta; --k) fp[k + offset] = snake(k);
    fp[delta + offset] = snake(delta);
    if (fp[delta + offset] == n) break;
  }
  const ses = (x, y, path) => {
    const array = path ? ses(path.x - path.length, path.y - path.length, path.path) : [];
    for (let i = path ? path.x : 0; i < x; ++i) array.push(-i - 1);
    for (let j = path ? path.y : 0; j < y; ++j) array.push(j);
    return array;
  };
  return ses(m, n, paths[delta + offset]);
}, _ArrayContentValue_insert = function _ArrayContentValue_insert(index, fragment) {
  const target = __classPrivateFieldGet(this, _ArrayContentValue_identities, "f")[index];
  if (target) target.insert(fragment);else this.end.before(fragment);
};
class TextContentValue extends ContentValue {
  constructor(start, end, value, message) {
    super(start, end, value);
    _TextContentValue_text.set(this, void 0);
    _TextContentValue_message.set(this, void 0);
    __classPrivateFieldSet(this, _TextContentValue_text, start.ownerDocument.createTextNode(''), "f");
    this.start.after(__classPrivateFieldGet(this, _TextContentValue_text, "f"));
    __classPrivateFieldSet(this, _TextContentValue_message, message, "f");
  }
  async render() {
    const text = toDOMString(this.value, __classPrivateFieldGet(this, _TextContentValue_message, "f"));
    if (text != __classPrivateFieldGet(this, _TextContentValue_text, "f").data) __classPrivateFieldGet(this, _TextContentValue_text, "f").data = text;
  }
  terminate() {}
  cache() {}
  uncache() {}
  collectElementTargets() {
    return [];
  }
}
exports.TextContentValue = TextContentValue;
_TextContentValue_text = new WeakMap(), _TextContentValue_message = new WeakMap();
class MarkupContentValue extends ContentValue {
  constructor() {
    super(...arguments);
    _MarkupContentValue_markup.set(this, '');
  }
  async render() {
    const markup = this.value.toString();
    if (markup == __classPrivateFieldGet(this, _MarkupContentValue_markup, "f")) return;
    const range = this.createInnerRange();
    range.deleteContents();
    range.insertNode(range.createContextualFragment(markup));
    __classPrivateFieldSet(this, _MarkupContentValue_markup, markup, "f");
  }
  terminate() {}
  cache() {}
  uncache() {}
  collectElementTargets() {
    return [];
  }
}
exports.MarkupContentValue = MarkupContentValue;
_MarkupContentValue_markup = new WeakMap();
class ObjectContentValue extends ContentValue {
  constructor(start, end, value, cache, owner) {
    super(start, end, value);
    _ObjectContentValue_children.set(this, []);
    _ObjectContentValue_targets.set(this, void 0);
    _ObjectContentValue_cache.set(this, void 0);
    if (cache.has(value)) {
      const _cache$pop = cache.pop(value),
        targets = _cache$pop.targets,
        fragment = _cache$pop.fragment;
      __classPrivateFieldSet(this, _ObjectContentValue_targets, targets, "f");
      this.createInnerRange().insertNode(fragment);
    } else {
      const tuples = owner.source.children.map(source => source.create(this.value, owner));
      __classPrivateFieldGet(this, _ObjectContentValue_children, "f").push(...tuples.map(tuple => tuple[0]));
      __classPrivateFieldSet(this, _ObjectContentValue_targets, tuples.map(tuple => tuple[1]).filter(target => target != null), "f");
    }
    __classPrivateFieldSet(this, _ObjectContentValue_cache, cache, "f");
  }
  async render(scope, context) {
    for (const target of __classPrivateFieldGet(this, _ObjectContentValue_targets, "f")) await target.render(scope, context);
    if (__classPrivateFieldGet(this, _ObjectContentValue_children, "f").length > 0) this.start.after(...__classPrivateFieldGet(this, _ObjectContentValue_children, "f").splice(0));
  }
  terminate() {
    for (const target of __classPrivateFieldGet(this, _ObjectContentValue_targets, "f")) if (target instanceof ElementTarget || target instanceof ContentTarget) target.terminate();
  }
  cache() {
    __classPrivateFieldGet(this, _ObjectContentValue_cache, "f").push(this.value, {
      targets: __classPrivateFieldGet(this, _ObjectContentValue_targets, "f"),
      fragment: this.createInnerRange().extractContents()
    });
  }
  uncache() {
    for (const target of __classPrivateFieldGet(this, _ObjectContentValue_targets, "f")) if (target instanceof ElementTarget || target instanceof ContentTarget) target.uncache();
  }
  collectElementTargets() {
    const targets = __classPrivateFieldGet(this, _ObjectContentValue_targets, "f").filter(target => target instanceof ElementTarget);
    return targets.flatMap(target => target.collectElementTargets());
  }
}
exports.ObjectContentValue = ObjectContentValue;
_ObjectContentValue_children = new WeakMap(), _ObjectContentValue_targets = new WeakMap(), _ObjectContentValue_cache = new WeakMap();
class Cache {
  constructor() {
    _Cache_caches.set(this, new Map());
  }
  push(value, cache) {
    if (__classPrivateFieldGet(this, _Cache_caches, "f").has(value)) __classPrivateFieldGet(this, _Cache_caches, "f").get(value).push(cache);else __classPrivateFieldGet(this, _Cache_caches, "f").set(value, [cache]);
  }
  pop(value) {
    const caches = __classPrivateFieldGet(this, _Cache_caches, "f").get(value);
    const cache = caches.pop();
    if (caches.length == 0) __classPrivateFieldGet(this, _Cache_caches, "f").delete(value);
    return cache;
  }
  has(value) {
    return __classPrivateFieldGet(this, _Cache_caches, "f").has(value);
  }
  clear() {
    __classPrivateFieldGet(this, _Cache_caches, "f").clear();
  }
}
_Cache_caches = new WeakMap();
class ContentCache extends Cache {}
exports.ContentCache = ContentCache;
class IdentityCache extends Cache {}
exports.IdentityCache = IdentityCache;
class IdentityContentTarget extends ContentTarget {
  constructor(owner, fragment, value, parent) {
    super(owner, fragment);
    this.value = value;
    this.parent = parent;
  }
  async render() {
    throw new Error();
  }
  async renderContent(context) {
    await this.updateValue();
    await super.renderContent(context);
  }
  evaluate() {
    return this.value;
  }
}
class RootContentTarget extends IdentityContentTarget {
  get message() {
    return 'data';
  }
}
class PropertyTarget extends DirectiveTarget {
  constructor(owner) {
    super('property', owner);
  }
  async render(scope) {
    Object.assign(this.owner.element, this.evaluate(scope));
  }
}
class CssVarTarget extends DirectiveTarget {
  constructor(owner) {
    super('cssvar', owner);
    _CssVarTarget_keys.set(this, new Array());
  }
  async render(scope) {
    const element = this.owner.element;
    const cssvars = this.evaluate(scope);
    for (const key of __classPrivateFieldGet(this, _CssVarTarget_keys, "f")) if (key in cssvars == false) cssvars[key] = null;
    for (const _ref14 of Object.entries(cssvars)) {
      var _ref15 = _slicedToArray(_ref14, 2);
      const key = _ref15[0];
      const value = _ref15[1];
      element.style.setProperty(`--${key}`, value);
    }
    __classPrivateFieldGet(this, _CssVarTarget_keys, "f").splice(0, __classPrivateFieldGet(this, _CssVarTarget_keys, "f").length, ...Object.keys(cssvars).filter(key => cssvars[key]));
  }
}
_CssVarTarget_keys = new WeakMap();
class CssclassTarget extends DirectiveTarget {
  constructor(owner) {
    super('cssclass', owner);
    _CssclassTarget_names.set(this, new Array());
  }
  async render(scope) {
    const names = Array(this.evaluate(scope)).flat();
    for (const name of __classPrivateFieldGet(this, _CssclassTarget_names, "f")) if (!names.includes(name)) this.owner.element.classList.remove(name);
    for (const name of names) this.owner.element.classList.add(name);
    __classPrivateFieldGet(this, _CssclassTarget_names, "f").splice(0, __classPrivateFieldGet(this, _CssclassTarget_names, "f").length, ...names);
  }
}
_CssclassTarget_names = new WeakMap();
class CssstyleTarget extends DirectiveTarget {
  constructor(owner) {
    super('cssstyle', owner);
    _CssstyleTarget_keys.set(this, new Array());
  }
  async render(scope) {
    const style = this.evaluate(scope);
    for (const key of __classPrivateFieldGet(this, _CssstyleTarget_keys, "f")) if (key in style == false) style[key] = '';
    Object.assign(this.owner.element.style, style);
    __classPrivateFieldGet(this, _CssstyleTarget_keys, "f").splice(0, __classPrivateFieldGet(this, _CssstyleTarget_keys, "f").length, ...Object.keys(style).filter(key => style[key]));
  }
}
_CssstyleTarget_keys = new WeakMap();
class AfterTarget extends DirectiveTarget {
  constructor(owner) {
    super('after', owner);
  }
  async render(scope) {
    this.evaluate(scope, true);
  }
}
class TextTarget extends Target {
  constructor(text, evaluator, object) {
    super();
    _TextTarget_text.set(this, void 0);
    _TextTarget_evaluator.set(this, void 0);
    _TextTarget_object.set(this, void 0);
    __classPrivateFieldSet(this, _TextTarget_text, text, "f");
    __classPrivateFieldSet(this, _TextTarget_evaluator, evaluator, "f");
    __classPrivateFieldSet(this, _TextTarget_object, object, "f");
  }
  async render(scope) {
    const data = __classPrivateFieldGet(this, _TextTarget_evaluator, "f").evaluate(__classPrivateFieldGet(this, _TextTarget_object, "f"), scope);
    if (data != __classPrivateFieldGet(this, _TextTarget_text, "f").data) __classPrivateFieldGet(this, _TextTarget_text, "f").data = data;
  }
}
_TextTarget_text = new WeakMap(), _TextTarget_evaluator = new WeakMap(), _TextTarget_object = new WeakMap();
function toDOMString(value, message) {
  if (value && typeof value == 'object' && value.toString == Object.prototype.toString) throw new Error(`Object.prototype.toString() is called implicitly (${message})`);
  return String(value);
}